import { ThemeOptions } from '@material-ui/core'
import { Overrides } from '@material-ui/core/styles/overrides'

export const ThemeOverrides = (theme: ThemeOptions): Overrides => {
  return {
    // WE CAN
  }
}
